var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.6,
    height: 34.986,
    viewBox: "0 0 24.6 34.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "locationline",
    transform: "translate(-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M88.3,0A12.3,12.3,0,0,0,77.836,18.768L87.6,34.5a1.025,1.025,0,0,0,.871.485h.008a1.025,1.025,0,0,0,.871-.5L98.865,18.6A12.3,12.3,0,0,0,88.3,0Zm8.806,17.549L88.455,31.993l-8.877-14.3a10.257,10.257,0,1,1,17.527-.139Z",
    transform: "translate(-76)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(82.15 6.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M172.15,90a6.15,6.15,0,1,0,6.15,6.15A6.157,6.157,0,0,0,172.15,90Zm0,10.264a4.114,4.114,0,1,1,4.107-4.114A4.117,4.117,0,0,1,172.15,100.264Z",
    transform: "translate(-166 -90)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8a6f6630b8bef5da30099137fec71e38.svg";
export { ForwardRef as ReactComponent };